"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.game = void 0;
const Size_1 = require("../../enums/game-center/Size");
const game_center_asset_1 = require("../../utils/game-center-asset");
exports.game = {
    id: '',
    gameId: '',
    isEnable: false,
    startDate: '',
    endDate: '',
    order: 1,
    name: '',
    game: '',
    unLockDays: 7,
    isGameLock: false,
    gameLockImage: '',
    gameSize: Size_1.Size.HALF,
    gameImageBackgroundStyle: {
        backgroundColor: '',
        borderRadius: '10px',
    },
    gameImage: (0, game_center_asset_1.getGameCenterAssetUrl)('game-placeholder.png'),
    isStartDateCountDown: false,
    countDownImage: '',
    gamificationId: '',
    gamificationType: null,
    attemptGamificationLockType: null,
};
